
import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
  getLatestHeadlines: () => Promise<HeadlinesData[]>;
}

interface Data {
  data: Record<string, any>;
  domain: string;
  headlines: HeadlinesData[];
  limit: number;
  settings: Record<string, any>;
}

interface Computed {
  showViews: boolean;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    HeadlineBlocks,
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      data: {
        items: [],
      },
      domain,
      headlines: [],
      limit: 12,
      settings: {
        channel: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
        videoDuration: true,
      },
    };
  },
  computed: {
    showViews() {
      return this.$channelConfig('settings').showViews ?? false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getTopHeadlines();
    });
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      const headlines = await this.getLatestHeadlines();
      if (headlines.length) {
        this.headlines = headlines.map((headline) => this.getHeadline(headline)) || [];
      }
    },
    async getLatestHeadlines() {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({ domain: this.domain, limit: this.limit, getViews: true });
      return headlines.items;
    },
  },
});
